import Animation from './animation'
import * as d3 from 'd3-selection'
import { EPSILON } from 'chart-constants'

/*
 * Basic Treemap animation
 */
class BasicTreemapAnimation extends Animation {

  match () {
    return true
  }

  animate (serie, enter, selection, merged, exit) {
    exit.selection().remove()

    enter.attr('transform', d => `translate(${d.x0},${d.y0})`)
         .select('rect')
         .attr('fill', d => this.colorScale(d.data.level))
         .attr('width', d => (d.x1 - d.x0))
         .attr('height', d => (d.y1 - d.y0))

    merged.attr('transform', d => `translate(${d.x0},${d.y0})`)
          .select('rect')
          .attr('fill', d => this.colorScale(d.data.level))
          .attr('width', d => d.x1 - d.x0)
          .attr('height', d => d.y1 - d.y0)
    merged.call(this._labels)
  }


}

export default BasicTreemapAnimation
